import { render, staticRenderFns } from "./CriticalitiesEvaluate.vue?vue&type=template&id=b2e80c22&scoped=true&"
import script from "./CriticalitiesEvaluate.vue?vue&type=script&lang=js&"
export * from "./CriticalitiesEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./CriticalitiesEvaluate.vue?vue&type=style&index=0&id=b2e80c22&scoped=true&lang=css&"
import style1 from "./CriticalitiesEvaluate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e80c22",
  null
  
)

export default component.exports